export default "skymp5-front/fb344395b65fad4dc9b2b4dbecaaf9ae.svg";